// Core AlignmentManager
import { AlignmentManager } from './AlignmentManager';
export { AlignmentManager };

// Alignment strategies
import { objectAlignmentStrategy, centerAlignmentStrategy } from './strategies';
export { objectAlignmentStrategy, centerAlignmentStrategy };

// Visualizers
export {
  drawAlignmentLine,
  drawAlignmentLines,
  drawVerticalAlignmentLine,
  drawHorizontalAlignmentLine,
} from './visualizers';

// Constants
import { ALIGNMENT_TYPES } from './constants';
export * from './constants';

// Singleton instance management
let alignmentManager = null;

/**
 * Initialize the alignment system
 * @param {fabric.Canvas} canvas - The fabric canvas
 * @param {Object} options - Configuration options
 * @returns {AlignmentManager} The alignment manager instance
 */
export function initAlignment(canvas, options = {}) {
  if (!canvas) {
    console.warn('initAlignment: No canvas provided');
    return null;
  }

  // Destroy existing manager if present
  if (alignmentManager) {
    alignmentManager.destroy();
  }

  // Create new AlignmentManager
  alignmentManager = new AlignmentManager(canvas, options);

  // Register default strategies using the constants
  alignmentManager.registerStrategy(
    ALIGNMENT_TYPES.OBJECT_TO_OBJECT,
    objectAlignmentStrategy
  );

  alignmentManager.registerStrategy(
    ALIGNMENT_TYPES.CANVAS_CENTER,
    centerAlignmentStrategy
  );

  return alignmentManager;
}

/**
 * Get the current alignment manager instance
 * @returns {AlignmentManager|null} The alignment manager or null if not initialized
 */
export function getAlignmentManager() {
  return alignmentManager;
}

/**
 * Update alignment options
 * @param {Object} options - New options to merge
 */
export function updateAlignmentOptions(options) {
  if (alignmentManager) {
    alignmentManager.updateOptions(options);
  }
}

/**
 * Destroy the alignment system
 */
export function destroyAlignment() {
  if (alignmentManager) {
    alignmentManager.destroy();
    alignmentManager = null;
  }
}
